import { getCountry } from '@iwIntlProvider/CountryProvider';
import { tracking } from '@iwoca/frontend-tracking-library';

import {
    AmountSliderUsedProperties,
    EventApprovalPayload,
    RepaymentScheduleViewedProperties
} from './amplitude.types';
import { AMPLITUDE_CATEGORY } from './amplitudeCategories';
import { AMPLITUDE_EVENT_NAMES } from './amplitudeEvents';

export const TrackAmountSliderUsed = (
    payloadObj: AmountSliderUsedProperties
) => {
    TrackApprovalEvent({
        event: AMPLITUDE_EVENT_NAMES.AMOUNT_SLIDER_USED,
        payload: payloadObj
    });
};

export const TrackRepaymentScheduleViewed = (
    payloadObj: RepaymentScheduleViewedProperties
) => {
    TrackApprovalEvent({
        event: AMPLITUDE_EVENT_NAMES.REPAYMENT_SCHEDULE_VIEWED,
        payload: payloadObj
    });
};

const TrackApprovalEvent = ({
    event,
    payload
}: {
    event: string;
    payload: EventApprovalPayload;
}) => {
    tracking.ampli.track({
        event_type: event,
        event_properties: {
            ...payload,
            category:
                getCountry() === 'DE'
                    ? AMPLITUDE_CATEGORY.APPROVAL_DE
                    : AMPLITUDE_CATEGORY.APPROVAL
        }
    });
};

export const TrackErrorModalOpened = () => {
    tracking.ampli.track({
        event_type: AMPLITUDE_EVENT_NAMES.ERROR_MODAL_OPENED,
        event_properties: {
            URL: window.location.pathname,
            category:
                getCountry() === 'UK'
                    ? AMPLITUDE_CATEGORY.ACCOUNT_PAGES
                    : AMPLITUDE_CATEGORY.ACCOUNT_PAGES_DE
        }
    });
};
